import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, CanMatchFn } from '@angular/router';
import { UserState } from '@shared/states/user.state';

export const ManagerCanActivateGuard: CanActivateFn = () => {
  const userState = inject(UserState);

  return !userState.isClient;
};

export const ManagerCanActivateChildGuard: CanActivateChildFn = () => {
  const userState = inject(UserState);

  return !userState.isClient;
};

export const ManagerCanMatchGuard: CanMatchFn = () => {
  const userState = inject(UserState);

  return !userState.isClient;
};
